import React from 'react';
import Select from 'react-select';

const ComSelect = (props) => {
    return <>
        <div className="d-none d-md-block">
            <Select {...props} />
        </div>
        <div className="d-block d-md-none">
            <Select
                {...props}
                isSearchable={false} // Disable search in mobile view
            />
        </div>
    </>
}

export default ComSelect;